module.exports = __webpack_public_path__ + "img/thumbnail-cedrow-grid-icons.2f5b6944.webp";